import {
    Stack,
    Typography,
    Button,
    Paper,
} from "@mui/material";

export default function BackupSettings() {
    return (
        <>
            <Typography
                sx={{
                    fontSize: 24,
                    fontWeight: 700,
                    mb: 0.5,
                }}
            >
                Backup System
            </Typography>

            <Typography sx={{ color: "#777", mb: 4 }}>
                Backup and restore your data
            </Typography>

            <Stack spacing={3}>
                <Paper
                    variant="outlined"
                    sx={{
                        p: 3,
                        borderRadius: 3,
                    }}
                >
                    <Typography fontWeight={700} mb={1}>
                        Export Database
                    </Typography>

                    <Typography
                        sx={{
                            color: "#777",
                            mb: 2,
                        }}
                    >
                        Download a full backup copy
                    </Typography>

                    <Button
                        variant="contained"
                        sx={{
                            backgroundColor: "#111",
                            borderRadius: 3,
                            textTransform: "none",
                        }}
                    >
                        Export Backup
                    </Button>
                </Paper>

                <Paper
                    variant="outlined"
                    sx={{
                        p: 3,
                        borderRadius: 3,
                    }}
                >
                    <Typography fontWeight={700} mb={1}>
                        Restore Database
                    </Typography>

                    <Typography
                        sx={{
                            color: "#777",
                            mb: 2,
                        }}
                    >
                        Restore from backup file
                    </Typography>

                    <Button
                        variant="contained"
                        sx={{
                            backgroundColor: "#111",
                            borderRadius: 3,
                            textTransform: "none",
                        }}
                    >
                        Restore Backup
                    </Button>
                </Paper>
            </Stack>
        </>
    );
}